import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

// デフォルトのステートを変数に格納
const getDefaultState = () => {
  return {
    user: null,
    idToken: null,
    accessToken: null,
    username: null,
    registCourseId: null,
    currentUnit: null,
    currentLesson: null,
    pjmUserId: null
  }
}

export default new Vuex.Store({
  state: getDefaultState(),
  mutations: {
    setUser (state, user) {
      state.user = user
    },
    setCurrentLesson (state, currentLesson) {
      state.currentLesson = currentLesson
    },
    setCurrentUnit (state, currentUnit) {
      state.currentUnit = currentUnit
    },
    setLoginUser (state, user) {
      state.user = user
    },
    setRegistCourseId (state, id) {
      state.registCourseId = id
    },
    deleteRegistCourseId (state) {
      state.registCourseId = null
    },
    deleteLoginUser (state) {
      state.user = null
    },
    setIdToken (state, idToken) {
      state.idToken = idToken
    },
    setUserName (state, username) {
      state.username = username
    },
    setAccessToken (state, accessToken) {
      state.accessToken = accessToken
    },
    reset (state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    setCurrentLesson ({ commit }, currentLesson) {
      commit('setCurrentLesson', currentLesson)
    },
    setCurrentUnit ({ commit }, currentUnit) {
      commit('setCurrentUnit', currentUnit)
    },
    async setLoginUser ({ commit }, user) {
      commit('setLoginUser', user)
    },
    signIn () {},
    signOut () {},
    deleteLoginUser ({ commit }) {
      commit('deleteLoginUser')
    }
  },
  getters: {
    user: (state) => (state.user ? state.user : null),
    idToken: (state) => (state.idToken ? state.idToken : null),
    username: (state) => (state.username ? state.username : null)
  },
  // vuex-persisted-state
  plugins: [
    createPersistedState({
      key: 'platjam',
      storage: window.sessionStorage,
      paths: ['currentUnit', 'currentLesson']
    }),
    createPersistedState({
      key: 'platjam',
      storage: window.localStorage,
      paths: ['idToken', 'accessToken', 'registCourseId', 'user', 'username']
    })
  ]
})
